import React, { useEffect } from "react";
import * as app from "../services/AppService";
import Dialog from "./PublicDialogs/Dialog";
import { RowItem } from "../models/Core/row-item";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import TooltipElm from 'react-bootstrap/Tooltip';
import CameraCapture from "./CameraCapture"

interface Props extends RowItem {
    model: string | null | undefined;
    onChange?: (...args: any) => any;
    title?: string;
    isTable?: boolean;
    displayAsButton?: boolean;
    size?: string;
    titleClass?: string;
    noDeleteButton?: boolean;
    class?: string;
    isCompact?: boolean
    compatColor?: string
}

export default function ImageUpload(props:Props) {

    const [state, setState] = React.useState({
        show: false,
        showCameraCapture: false,
        DialogImage: '',
        ImageSrc: "#",
        file:"",
        showImgCard: false
    });

    useEffect(() => {
        let ImageSrc = !props.model || props.model.length == 0 ? "#" : props.model.includes("data:") ? props.model :
            (props.model.startsWith("JVBERi0xLj") ? "data:application/pdf;base64," : "data:image/jpeg;base64,") + props.model;
        setState(old => ({
            ...old,
            showImgCard: props.model && props.model.length > 0 ? true : false,
            ImageSrc,
            file: ImageSrc
        }));
    }, [props.model]);
    //! Handle Image Upload In The Table:
    if (props.isTable) {
        return (
            <>
                {state.showImgCard ? (
                    <div className="d-flex align-items-center  gap-1">
                        <img
                            src={state.ImageSrc}
                            alt=""
                            className="rounded border border-1 border-primary hover-shadow-card"
                            style={{ width: 100, height: 60, objectFit: "cover" }}
                        />
                        <div className="d-flex flex-column gap-1">
                        <TooltipTrigger tooltipTitle="view">
                            <button
                                type="button"
                                onClick={openDialog}
                                className="btn btn-sm btn-primary d-flex align-items-center justify-content-center"
                                style={{ width: 28, height: 28, padding: 0 }}
                            >
                                <i className="iconssc-eye" style={{ fontSize: 13 }}></i>
                            </button>
                        </TooltipTrigger>
                        {!props.noDeleteButton && (
                            <TooltipTrigger tooltipTitle="Delete">
                                <button
                                    type="button"
                                    onClick={removeUpload}
                                    className="btn btn-sm btn-danger d-flex align-items-center justify-content-center"
                                    style={{ width: 28, height: 28, padding: 0 }}
                                >
                                    <i className="iconssc-trash" style={{ fontSize: 13 }}></i>
                                </button>
                            </TooltipTrigger>
                            )}
                        </div>
                    </div>
                ) : (
                    /* When no image: show upload + camera side by side */
                    <div className="d-flex align-items-center gap-1">
                        <TooltipTrigger tooltipTitle="UploadImage">
                            <label
                                htmlFor={"img-upload-input" + props.title}
                                className="btn btn-sm btn-outline-warning d-flex align-items-center justify-content-center mb-0"
                                style={{ width: 35, height: 35, padding: 0, cursor: "pointer" }}
                                >
                                <i className="fas fa-cloud-upload-alt" style={{ fontSize: 13 }}></i>
                            </label>
                        </TooltipTrigger>
                        <input
                            className="d-none"
                            id={"img-upload-input" + props.title}
                            type="file"
                            onChange={readURL}
                            accept="image/*"
                        />
                        <TooltipTrigger tooltipTitle="TurnOnCamera">
                            <button
                                type="button"
                                className="btn btn-sm btn-primary d-flex align-items-center justify-content-center"
                                style={{ width: 35, height: 35, padding: 0 }}
                                onClick={() => setState(old => ({ ...old, showCameraCapture: true }))}
                            >
                                <i className="fa-solid fa-camera" style={{ fontSize: 13 }}></i>
                            </button>
                        </TooltipTrigger>
                    </div>
                )}
                <Dialog show={state.show} size="md" onClose={() => setState(old => ({ ...old, show: false }))} ok={() => {
                    const a: any = document.getElementById('download')
                    a.click()
                }} okLabel="Loading">
                    {state.DialogImage as any}
                    <a className="d-none" id="download" href={state.ImageSrc} color="transparent" target="_blank" rel="noreferrer" download>
                        {app.translate("Loading")}
                    </a>
                </Dialog>
                <CameraCapture
                    show={state.showCameraCapture}
                    onImageCaptured={ImageSrc => {
                        //@ts-ignore
                        selectedImgChanged(ImageSrc.split("base64,")[1], "CameraImage");
                        setState(old => ({ ...old, showCameraCapture: false, ImageSrc, file: ImageSrc }))
                    }}
                    onClose={() => setState(old => ({ ...old, showCameraCapture: false }))}
                />
            </>
        );
    }
    function readURL(event:any) {
        var input = event.target;
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.onload = function (e) {
                var ImageSrc = e.target!.result;
                //@ts-ignore
                selectedImgChanged(e.target.result.split("base64,")[1], input.files?.[0]?.name)

                setState(old => ({ ...old, showImgCard: true, ImageSrc, file: ImageSrc } as any));
            };
            reader.readAsDataURL(input.files[0]);
            if (props.displayAsButton) {
                const fileChosen = document.getElementById("fileChosen")!;
                fileChosen.textContent = input.files?.[0]?.name;
            }
        } else {
            removeUpload();
        }
    }
    function selectedImgChanged(img: any, fileName: any) {
        if (props.onChange && typeof (props.onChange) == "function")
            props.onChange(img, fileName)
    }

    function openDialog() {
        if (state.file.split("base64,")?.[0]?.includes("image"))
            setState(old => ({
                ...old, show: true,
                DialogImage: (<img className="card-img-top" src={old.ImageSrc} alt="" id={"file-upload-image" + props.title} />)
            } as any))
        else {
            const fileWindow = window.open("")!;
            fileWindow.document.write("<iframe width='100%' height='100%' src='" + encodeURI(state.file) + "'></iframe>");
        }
    }

    function removeUpload() {
        setState(old => ({ ...old, ImageSrc: "#", showImgCard: false }));
        selectedImgChanged("","")
    }

    if (props.displayAsButton) {
        return (
            <div className="row">
                <div className={"col-12 d-flex align-items-center gap-2 " + props.class}>

                    <label className="w-auto form-control" htmlFor={"img-upload-input" + props.title}>
                        {app.translate(props.title)}
                        <span className="iconssc-cloud ms-2"></span>
                    </label>
                    <input className="d-none" id={"img-upload-input" + props.title} type='file' onChange={readURL} accept="image/*"   />
                    <span id="fileChosen" className="col-auto"></span>

                </div>
            </div>
        );
    } else {     
        return (
            <div className="row">
                <div>
                    {props.title && <h6 className={`text-primary-emphasis ${props.titleClass}`}>{app.translate(props.title)}</h6>}

                    <div className={`card bg-body border-primary-subtle card-primary-subtle text-center ${props.size === "md" ? "spacing-md" : ""} ${props.isTable ? "row mx-2" : ""}`}
                        style={{
                            "width": props.size === "lg" ? "400px" : props.size === "sm" ? "100px" : "200px",
                            "height": props.isCompact ? "" : props.size === "lg" ? "260px" : props.size === "sm" ? "100px" : "200px"
                        }}>

                        {!state.showImgCard &&
                            <div id={"image-upload-wrap" + props.title}>
                                <div className={"text-primary-emphasis d-flex align-items-center justify-content-center " + (props.isCompact
                                    ? "p-2 gap-2 "
                                    : "flex-column " + (!props.isTable && !props.size ? " card-img-overlay" : "") + (props.size ? "mt-3 gap-2 " : "")
                                )}>
                                    {props.isCompact ? (
                                        <TooltipTrigger tooltipTitle="UploadImage">
                                            <label
                                                htmlFor={"img-upload-input" + props.title}
                                                style={{ cursor: "pointer", margin: 0, position: "relative", zIndex: 2 }}
                                            >
                                                <i
                                                    className={`fas fa-cloud-upload-alt fs-1 text-${props.compatColor}`}
                                                ></i>
                                            </label>
                                        </TooltipTrigger>
                                    ) : (
                                        <i className={`fas fa-cloud-upload-alt  ${!props.isTable ? 'fs-1' : 'fs-4'}`}></i>
                                    )}
                                    {(!props.isTable && !props.size) && !props.isCompact &&
                                        <h5 className="fs-6">{app.translate("UploadImage")}</h5>
                                    }
                                    <TooltipTrigger tooltipTitle="TurnOnCamera">
                                        <button className={`btn ${props.compatColor !== "" ? `bg-${props.compatColor}-subtle border border-${props.compatColor}` : "btn-primary"} camera-button`} onClick={() => { setState(old => ({ ...old, showCameraCapture: true })); }}>
                                            <i className={`fa-solid fa-camera fs-6 mt-1 ${props.compatColor !== "" ? `text-${props.compatColor}`:""}`}></i>
                                           </button>
                                        </TooltipTrigger>
                                </div>

                                <input className="form-control position-absolute top-0 start-0 w-100 h-100" id={"img-upload-input" + props.title} type='file'
                                    onChange={readURL} accept="image/*" style={{ "height": props.isTable ? "50px" : props.size === "lg" ? "260px" : props.size==="sm" ? "100px" : "150px", "opacity": "0" }} />
                            </div>}

                        {state.showImgCard &&
                            <div className="card-body p-1">
                                <img className="card-img-top rounded" style={{ "height": props.isTable ? "50px" : props.size === "lg" ? "210px" : props.size === "md" ? "80px" : props.size === "xs" ? "100px" : props.size === "sm" ? "100px" : props.isCompact ? "75px" : "148px" }} src={state.ImageSrc} alt="" id={"file-upload-image" + props.title} />
                            </div>}

                        {state.showImgCard &&
                            <div className={` ${props.size === "sm" ? "position-absolute bg-opacity-50 w-100 fixed-bottom" : ""}  card-footer ${!props.isTable ? 'bg-dark' : 'col bg-transparent border-0 py-0 px-3 w-auto'}`}>
                                <div className="row ">
                                    {!props.noDeleteButton &&
                                        <TooltipTrigger tooltipTitle="Delete">
                                            <button type="button" onClick={removeUpload} className={`btn btn-sm btn-danger rounded mx-1 ${!props.isTable ? 'col' : 'p-0'}`}><i className="iconssc-trash"></i></button>
                                        </TooltipTrigger>
                                    }
                                    <TooltipTrigger tooltipTitle="view">
                                        <button type="button" onClick={openDialog} className={`btn btn-sm bg-primary rounded  mx-1 ${!props.isTable ? 'col' : 'p-0'}`}><i className="iconssc-eye text-white"></i></button>
                                    </TooltipTrigger>
                                </div>
                            </div>}
                    </div>
                    <Dialog show={state.show} size="md" onClose={() => setState(old => ({ ...old, show: false }))} ok={() => {
                        const a :any= document.getElementById('download')
                        a.click()
                    }} okLabel="Loading">
                        {state.DialogImage as any}

                        <a className="d-none" id="download"
                            href={state.ImageSrc}
                            color="transparent"
                            target="_blank"
                            rel="noreferrer"
                            download>{app.translate("Loading")}
                        </a>
                    </Dialog>

                    <CameraCapture show={state.showCameraCapture}
                        onImageCaptured={ImageSrc => {
                            //@ts-ignore
                            selectedImgChanged(ImageSrc.split("base64,")[1], "CameraImage");
                            setState(old => ({ ...old, showCameraCapture: false, ImageSrc, file: ImageSrc }))
                        }}
                        onClose={() => setState(old => ({ ...old, showCameraCapture: false }))} />
                </div>
            </div>
        );
    }
}


ImageUpload.defaultProps = {
    model: "",
    title: "",
    isTable: false,
    displayAsButton: false,
    size: "",
    titleClass: "",
    noDeleteButton: false
};

const TooltipTrigger = ({ children, tooltipTitle }: { children: React.ReactElement, tooltipTitle: string }) => {
    return (
        <OverlayTrigger key={'bottom'} placement='bottom'
            overlay={
                <TooltipElm style={{ position: "fixed" }} id={`tooltip-bottom`}>
                    {app.translate(tooltipTitle)}
                </TooltipElm>
            }>
            {children}
        </OverlayTrigger>
    )}